import { ViewEventHandler } from '../../common/viewEventHandler.js';
class DynamicViewOverlay extends ViewEventHandler {
}
export { DynamicViewOverlay };
